import { ThreeEvent } from '@react-three/fiber';
import { FunctionComponent } from 'react';
import * as THREE from 'three';

// todo: handle scale internally based on camera distance
const PointX: FunctionComponent<{
  scale: number;
  position: THREE.Vector3;
  onPointerDown?: (e: ThreeEvent<PointerEvent>) => void;
}> = ({ scale, position, onPointerDown }) => (
  <group scale={[scale, scale, scale]} position={position.toArray()} onPointerDown={onPointerDown}>
    <mesh renderOrder={Number.MAX_SAFE_INTEGER}>
      <boxGeometry args={[2, 0.1, 0.1]} />
      <meshBasicMaterial color='red' transparent opacity={0.8} depthTest={false} />
    </mesh>
    <mesh rotation={[0, 0, Math.PI / 2]} renderOrder={Number.MAX_SAFE_INTEGER}>
      <boxGeometry args={[2, 0.1, 0.1]} />
      <meshBasicMaterial color='red' transparent opacity={0.8} depthTest={false} />
    </mesh>
    <mesh rotation={[0, Math.PI / 2, 0]} renderOrder={Number.MAX_SAFE_INTEGER}>
      <boxGeometry args={[2, 0.1, 0.1]} />
      <meshBasicMaterial color='red' transparent opacity={0.8} depthTest={false} />
    </mesh>
    <mesh renderOrder={Number.MAX_SAFE_INTEGER}>
      <sphereGeometry args={[0.2, 8, 8]} />
      <meshBasicMaterial color='red' transparent opacity={0.8} depthTest={false} />
    </mesh>
  </group>
);

export default PointX;
